// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  SERVER_API_URL: 'https://api.fma.dev.techland.link/service-marketing/',
  CRM_API_URL: 'https://api.fma.dev.techland.link/crm/',
  urlUploadBackEnd : 'https://upload.dev.techland.link',
  linkFmarket: 'https://fma.dev.techland.link/',
  KEY_TOKEN: 'token',
  MAX_FILE_SIZE: 5 * 1024 * 1024,
  MAX_QUEUE_LIMIT: 5
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
